module.exports = __webpack_public_path__ + "static/media/24Streets.f3bec699.jpeg";